import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";

// Helper to check if URL is valid for redirect
const isValidRedirectUrl = (url) => {
  if (!url) return false;
  // Don't redirect to login page or empty paths
  const invalidPaths = ['/user-pages/login-1', '/user-pages/login', '/login', '/', ''];
  return !invalidPaths.includes(url);
};

function ProtectedRoute({
  component: Component,
  accesstype = [],
  ...restOfProps
}) {
  const [cookies] = useCookies(["user"]);
  const location = useLocation();
  const isAuthenticated = cookies?.user?.auth === "verified";

  // Save intended URL before redirecting to login (for shared links or direct access)
  const saveIntendedUrl = () => {
    const currentPath = location.pathname + location.search;
    if (isValidRedirectUrl(currentPath)) {
      // Only save if we don't already have a saved URL
      const existingUrl = sessionStorage.getItem('redirectAfterLogin');
      if (!existingUrl) {
        sessionStorage.setItem('redirectAfterLogin', currentPath);
      }
    }
  };

  return (
    <Route
      {...restOfProps}
      render={(props) => {
        if (isAuthenticated && accesstype?.includes(cookies?.user?.role)) {
          return <Component {...props} />;
        } else {
          // Save intended URL before redirecting to login
          saveIntendedUrl();
          return <Redirect to="/user-pages/login-1" />;
        }
      }}
    />
  );
}

export default ProtectedRoute;
